"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reachesOrExceedsCharacterLimit = exports.getWidgetText = exports.getStrippedHtml = exports.appendEllipsis = exports.CardWidgetText = void 0;

var _preact = require("preact");

var _ClampLines = _interopRequireDefault(require("@insided/shared/uikit/ClampLines"));

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

var getStrippedHtml = function getStrippedHtml(html) {
  return _htmlParser.default.stripHtml(html) || '';
};

exports.getStrippedHtml = getStrippedHtml;

var reachesOrExceedsCharacterLimit = function reachesOrExceedsCharacterLimit(text, characterLimit) {
  return characterLimit !== undefined && text.length >= characterLimit;
};

exports.reachesOrExceedsCharacterLimit = reachesOrExceedsCharacterLimit;

var appendEllipsis = function appendEllipsis(text, characterLimit) {
  return "".concat(text.substring(0, characterLimit).trimEnd(), "...");
};

exports.appendEllipsis = appendEllipsis;

var getWidgetText = function getWidgetText(content, characterLimit) {
  var containsHtml = /<[a-zA-Z/!]/.test(content);
  var text = containsHtml ? getStrippedHtml(content) : content;
  return reachesOrExceedsCharacterLimit(text, characterLimit) ? appendEllipsis(text, characterLimit || 0) : text;
};

exports.getWidgetText = getWidgetText;

var CardWidgetText = function CardWidgetText(_ref) {
  var content = _ref.content,
      characterLimit = _ref.characterLimit;
  return (0, _preact.h)("p", {
    className: "card-widget-text"
  }, (0, _preact.h)(_ClampLines.default, {
    id: "featured-topic-view",
    innerElement: "span",
    lines: 3,
    text: getWidgetText(content, characterLimit)
  }));
};

exports.CardWidgetText = CardWidgetText;